// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** Batch Delete SysUser (批量删除用户表) 根据ID列表批量删除用户表 DELETE /api/sys/user/batch-delete */
export async function batchDeleteSysUser(
  body: string[],
  options?: { [key: string]: any }
) {
  return request<API.ResultBoolean>("/api/sys/user/batch-delete", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** Change Password (修改密码) 用户修改自己的密码，需要验证旧密码 POST /api/sys/user/change-password */
export async function changePassword(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.changePasswordParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultMapStringString>("/api/sys/user/change-password", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Create SysUser (创建用户表) 创建新用户表 POST /api/sys/user/create */
export async function createSysUser(
  body: API.SysUserDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultBoolean>("/api/sys/user/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** Delete SysUser (删除用户表) 根据ID删除用户表 DELETE /api/sys/user/delete/${param0} */
export async function deleteSysUser(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteSysUserParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultBoolean>(`/api/sys/user/delete/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Get SysUser Detail (获取用户表详情) 获取用户表详情 GET /api/sys/user/detail/${param0} */
export async function getSysUserDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSysUserDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultSysUserDto>(`/api/sys/user/detail/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Get Login Name (根据ID查询登录名) 根据用户ID获取对应的登录名 GET /api/sys/user/login-name/${param0} */
export async function getLoginNameById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getLoginNameByIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultString>(`/api/sys/user/login-name/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Get User Names (批量获取用户名) 根据用户ID列表获取对应的用户名 POST /api/sys/user/names */
export async function getUserNames(
  body: string[],
  options?: { [key: string]: any }
) {
  return request<API.ResultMapStringString>("/api/sys/user/names", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** Get SysUser List (获取用户表分页列表) 获取用户表列分页列表 GET /api/sys/user/page */
export async function getSysUser4Page(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSysUser4PageParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultIPageSysUserVO>("/api/sys/user/page", {
    method: "GET",
    params: {
      ...params,
      arg0: undefined,
      ...params["arg0"],
      arg1: undefined,
      ...params["arg1"],
    },
    ...(options || {}),
  });
}

/** Reset User Password (重置用户密码) 管理员重置用户密码为默认密码123456 POST /api/sys/user/reset-password/${param0} */
export async function resetPassword(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.resetPasswordParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultBoolean>(`/api/sys/user/reset-password/${param0}`, {
    method: "POST",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Reset User Password By Login Name (根据登录名重置并发送密码) 管理员根据登录名查询邮箱，生成随机密码并发送给用户 POST /api/sys/user/reset-password/by-login-name */
export async function resetPasswordByLoginName(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.resetPasswordByLoginNameParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultBoolean>(
    "/api/sys/user/reset-password/by-login-name",
    {
      method: "POST",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** Update SysUser (更新用户表) 更新用户表信息 PUT /api/sys/user/update/${param0} */
export async function updateSysUser(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.updateSysUserParams,
  body: API.SysUserDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultBoolean>(`/api/sys/user/update/${param0}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}
